import { render, staticRenderFns } from "./popUpUrl.vue?vue&type=template&id=20655e48&scoped=true&"
import script from "./popUpUrl.vue?vue&type=script&lang=js&"
export * from "./popUpUrl.vue?vue&type=script&lang=js&"
import style0 from "./popUpUrl.vue?vue&type=style&index=0&id=20655e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20655e48",
  null
  
)

/* custom blocks */
import block0 from "./popUpUrl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports